import { FC } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { FillingExperience } from '@frontend/digital-forms-ui';

const routeApi = getRouteApi('/kiosk/new-patron_/$locationId');

export const KioskNewPatronFillingExperiencePage: FC = () => {
  const { locationId } = routeApi.useParams();
  const { formId, packetId } = routeApi.useSearch();

  if (formId) {
    return <FillingExperience.Actual.KioskForm documentId={formId} locationId={locationId} patronType='new' />;
  }

  if (packetId) {
    return <FillingExperience.Actual.KioskPacket documentId={packetId} locationId={locationId} patronType='new' />;
  }

  return <FillingExperience.FormNotFound variant='link-broken' locationId={locationId} />;
};
